import { EuiSpacer } from '@elastic/eui';
import PrimaryBoxInfo from 'components/Advanced_User/INSTAR_MQTT_Broker/OpenHAB2/PrimaryBox';
import PrimaryBox from 'components/Software/Linux/OpenHAB2/PrimaryBox';
import ForumBox from 'components/Software/Linux/OpenHAB2/ForumBox';
import NavButtons from 'components/Software/Linux/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  PrimaryBoxInfo,
  PrimaryBox,
  ForumBox,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};